import { ISaleCardListAdSlots } from '../../components/SaleCardList/SaleCardList.interfaces';
import { IPageName } from './apiSchema';

export const UPDATE_TRANSLATION_JSON: string = 'UPDATE_TRANSLATION_JSON';
export const UPDATE_SALE_CARD_LIST: string = 'UPDATE_SALE_CARD_LIST';
export const SE_API_TOKEN_VALUE: string = '5526da37-7566-41ee-b421-5069927962b7';
export const SE_API_TOKEN_KEY: string = 'se-api-token';

// <PriceValue /> translation keys
export const FROM_LABEL: string = 'common.fromPrice.label';
export const PER_PERSON_TEXT: string = 'offerPromotion.perPerson.text';

// <Deposit /> translation keys
export const DEPOSIT_FROM: string = 'sale.offers.depositFrom.text';

export const HOURS_IN_DAY: number = 24;
export const MINUTES_IN_HOUR: number = 60;
export const SECONDS_IN_MINUTE: number = 60;
export const SECONDS_IN_HOUR: number = MINUTES_IN_HOUR * SECONDS_IN_MINUTE;
export const MILLISECONDS_IN_SECOND: number = 1000;
export const MILLISECONDS_IN_DAY: number = MILLISECONDS_IN_SECOND * SECONDS_IN_HOUR * HOURS_IN_DAY;

export const FLASHSALES_MAIN_CONTAINER_WIDTH: string = '990px';
export const FLASHSALES_MAIN_CONTAINER_MAX_WIDTH: string = '1028px';

export const SALECARDLIST_AD_KEYS: { [k in IPageName]?: ISaleCardListAdSlots } = {
  [IPageName.collections]: {
    mediumRectangle: 'collections_mediumRectangle',
    midAd1: 'collections_billboard_atf',
  },
  [IPageName.currentSales]: {
    mediumRectangle: 'currentSales_mediumRectangle',
    midAd1: 'currentSales_midWidthCS1',
    midAd2: 'currentSales_midWidthCS2',
  },
  [IPageName.searchResults]: {
    mediumRectangle: 'currentSales_mediumRectangle',
    midAd1: 'currentSales_midWidthCS1',
    midAd2: 'currentSales_midWidthCS2',
  },
};
